'use client';
import Logo, { LogoProps } from '../../../logo';
import useScroll from './useScroll';
import { FIXED_HEIGHT } from '../common/constant';
import { useNavTheme } from '../NavThemeContext';

type Props = LogoProps & {
  isMobile?: boolean;
};

const ColorLogo = ({ isMobile, height, ...rest }: Props) => {
  const { isTop } = useScroll();
  const { topBarTheme } = useNavTheme();
  const mode = isTop && topBarTheme === 'dark' ? 'dark' : 'light';
  return (
    <Logo
      {...rest}
      withLink
      mode={mode}
      height={isMobile ? FIXED_HEIGHT.m : height || FIXED_HEIGHT.d}
    />
  );
};

export default ColorLogo;
